import { Injectable } from '@angular/core';

export interface ScriptConfig{
  name: string;
  src: string;
  loaded: boolean;
}

declare var document: any;

@Injectable({
  providedIn: 'root'
})
export class DynamicScriptLoaderService {
  private scripts: any = {};

  constructor() {}

  loadScript(name: string, url: string): Promise<ScriptConfig> {
    return new Promise((resolve, reject) => {
      if (!this.scripts[name]  || !this.scripts[name].loaded) {
        this.scripts[name] = {
          name, src: url
        };
        const script: any = document.createElement('script');
        script.type = 'text/javascript';
        script.src = this.scripts[name].src;
        if (script.readyState) {  // IE
          script.onreadystatechange = () => {
            if (script.readyState === 'loaded' || script.readyState === 'complete') {
              script.onreadystatechange = null;
              this.scripts[name].loaded = true;
              resolve(this.scripts[name]);
            }
          };
        } else {  // Others
          script.onload = () => {
            this.scripts[name].loaded = true;
            resolve(this.scripts[name]);
          };
        }
        script.onerror = (error: any) => {
          console.error('Error on loading script');
          console.error(error);
          this.scripts[name].loaded = false;
          resolve(this.scripts[name]);
        };
        document.getElementsByTagName('head')[0].appendChild(script);
      } else {
        resolve(this.scripts[name]);
      }
    });
  }
}
